import { render, staticRenderFns } from "./DoubleCard.vue?vue&type=template&id=96f35fce&scoped=true&functional=true&"
import script from "./DoubleCard.vue?vue&type=script&lang=js&"
export * from "./DoubleCard.vue?vue&type=script&lang=js&"
import style0 from "./DoubleCard.vue?vue&type=style&index=0&id=96f35fce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "96f35fce",
  null
  
)

export default component.exports